"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebVitals = void 0;
const web_vitals_1 = require("web-vitals");
const reportWebVitals = () => {
    (0, web_vitals_1.onCLS)(console.log);
    (0, web_vitals_1.onINP)(console.log);
    (0, web_vitals_1.onLCP)(console.log);
};
exports.reportWebVitals = reportWebVitals;
